// Web port of app/src/lib/crewColor.ts. Deterministic color-per-user so
// the same teammate keeps the same color every time you look at the map
// or the messages list.

const PALETTE = [
  '#e8823a', // amber (reserved for self)
  '#4fa3d1', // sky blue
  '#e55353', // red
  '#7eb356', // sage green
  '#c27ad1', // lavender
  '#f0c050', // mustard
  '#56c7b3', // teal
  '#ed7ab3', // pink
  '#9a8cd4', // periwinkle
  '#8ba86b', // olive
  '#d88a4a', // burnt orange
  '#6ba0d8', // powder blue
];

function hash(id: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < id.length; i++) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function crewColor(userId: string): string {
  const idx = 1 + (hash(userId) % (PALETTE.length - 1));
  return PALETTE[idx];
}

export const SELF_COLOR = PALETTE[0];

// Convert "#rrggbb" to "rgba(r, g, b, a)". Used for tinted message bubbles
// where a fully-saturated pin color would be garish as a background.
export function hexWithAlpha(hex: string, alpha: number): string {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!m) return hex;
  const r = parseInt(m[1], 16);
  const g = parseInt(m[2], 16);
  const b = parseInt(m[3], 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
